import apiService from './api-service';

export const driverService = {
	getDriver,
	getDrivers,
	createDriver,
	updateDriver,
	deleteDriver
};

async function getDrivers() {
	const drivers = await apiService.get('driver/getDrivers');
	return drivers;
}

async function getDriver(driverId) {
	const options = [
		{
			name: "driverId",
			value: driverId
		}
	];

	const driver = await apiService.get('driver/getDriver', options);
	return driver;
}

async function createDriver(driver) {
	const countInsertedRows = await apiService.post('driver/createDriver', driver);
	return countInsertedRows;
}

async function updateDriver(driver) {
	const countUpdatedRows = await apiService.post('driver/updateDriver', driver);
	return countUpdatedRows;
}

async function deleteDriver(driverId) {
	const driver = { driverId: driverId };

	const countDeletedRows = await apiService.post('driver/deleteDriver', driver);
	return countDeletedRows;
}